const RouteTest = () => {
    return <h2 style={{ color: '#BEEF69' }}>This is a new page</h2>;
};

export default RouteTest;
